import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';


import { AppRoutingModule } from './app.routing';
import { PipesModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';
import { MaterialModule } from './shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';

// components
import { AppComponent } from './app.component';
import { ChargeComponent } from './pages/charge/charge.component';
import { DestinationAccountComponent } from './pages/charge/components/destination-account/destination-account.component';
import { PaymentInfoComponent } from './pages/charge/components/payment-info/payment-info.component';
import { TransactionStatusComponent } from './pages/charge/components/transaction-status/transaction-status.component';
import { PaymentFormComponent } from './pages/charge/components/payment-form/payment-form.component';
import { FooterModule } from './shared/footer/footer.module';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    FooterModule,
    ReactiveFormsModule,
    MaterialModule,
    DirectivesModule,
    PipesModule
  ],
  declarations: [
    AppComponent,
    ChargeComponent,
    DestinationAccountComponent,
    PaymentInfoComponent,
    TransactionStatusComponent,
    PaymentFormComponent
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
